import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="py-24 px-6 lg:px-12 max-w-6xl mx-auto" data-id="element-10" data-mp="2prgzb5u7ihd9">
      <div className="bg-crema-light rounded-[3rem] p-8 md:p-12 lg:p-16 shadow-neumorph" data-id="element-11" data-mp="2prqpatf94oiy">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-12" data-mp="2tripoiuhrod8">
          <motion.div className="relative flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-13" data-mp="2yt7zxw9w3y09">
            <div className="relative w-full max-w-sm aspect-[4/5]" data-id="element-14" data-mp="3hhczssnfeyts">
              <div className="absolute inset-0 bg-terracota/20 blob-shape transform -translate-x-4 translate-y-4" data-id="element-15" data-mp="3mi9f02d8a7ei"></div>
              <img src="https://images.unsplash.com/photo-1594824476967-48c8b964ac31?w=600&q=80" alt="Lic. María Alejandra Ruiz" className="relative z-10 w-full h-full object-cover blob-shape shadow-lg" data-id="element-16" data-mp="3rhvruap59lms" />
            </div>
          </motion.div>

          <motion.div className="space-y-6" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-17" data-mp="2crkh3kpe709w">
            <div data-id="element-18" data-mp="2vo3s6fjray93">
              <h2 className="text-4xl font-serif text-dark mb-2" data-id="element-19" data-mp="2vnkamzy0qbvl">
                Lic. María Alejandra Ruiz
              </h2>
              <p className="text-terracota font-medium tracking-wide" data-id="element-20" data-mp="3o5pkabhs7646">
                Psicóloga Clínica — M.N. 45.892
              </p>
            </div>

            <div className="space-y-4 text-medium leading-relaxed" data-id="element-21" data-mp="3je7l9szbjflu">
              <p data-id="element-22" data-mp="65bxf9lftg39">
                Creo firmemente en el poder transformador de la palabra y en la
                capacidad innata que todos tenemos para sanar. Mi enfoque
                terapéutico es profundamente humano, centrado en crear un
                espacio libre de juicios donde puedas ser tú mismo.
              </p>
              <p data-id="element-23" data-mp="1dke9k4m2cn5">
                Con más de 10 años de experiencia clínica y formación continua
                en terapias contextuales, te acompaño a descubrir herramientas
                prácticas para afrontar los desafíos de la vida diaria,
                comprender tus emociones y construir relaciones más sanas.
              </p>
              <p data-id="element-24" data-mp="3elnhl64rg829">
                Cada proceso es único, y mi compromiso es caminar a tu lado
                respetando tus tiempos y necesidades.
              </p>
            </div>

            <div className="pt-4" data-id="element-25" data-mp="18qkp9uxutomr">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Signature_of_John_Hancock.svg/1200px-Signature_of_John_Hancock.svg.png" alt="Firma" className="h-12 opacity-40 filter grayscale" data-id="element-26" data-mp="1cush40zlzkp7" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}